/* eslint-disable no-console */
type logMethod = 'error' | 'warn' | 'log';
const colors = {
  reset: '\x1b[0m', // default
  error: '\x1b[31m', // Red
  warn: '\x1b[38;2;255;165;0m', // orange
  log: '\x1b[35m', // magneta
};

const timestamp = `[${new Date().toLocaleString()}]`;
const isLoggDisabled = !((import.meta as { env?: { DEV?: boolean } }).env?.DEV);

const createLoggerMethod =
  (method: logMethod) =>
  (...args: unknown[]) => {
    if (isLoggDisabled) return;
    const color = colors[method] || colors.log;
    const reset = colors.reset;

    console[method](`\n${color}${timestamp} ${method.toUpperCase()}${reset}`, ...args, `\n`);
  };

export const logger = {
  error: createLoggerMethod('error'),
  warn: createLoggerMethod('warn'),
  log: createLoggerMethod('log'),
};
